// src/utils/checkout.ts
var parseCheckoutError = (err) => {
  var _a;
  const possibleObj = typeof err.message === "object" ? err.message : err == null ? void 0 : err.errors;
  const possibleErrorsList = possibleObj || {};
  const possibleFirstError = (_a = Object.values(possibleErrorsList)) == null ? void 0 : _a[0];
  const possibleFirstMsg = typeof possibleFirstError === "string" ? possibleFirstError : possibleFirstError == null ? void 0 : possibleFirstError[0];
  err.message = possibleFirstMsg || (err == null ? void 0 : err.message);
  const possibleTicketErrors = err;
  return possibleTicketErrors == null ? void 0 : possibleTicketErrors.ticket_errors;
};

export {
  parseCheckoutError
};
//# sourceMappingURL=chunk-WWLG26XU.mjs.map